"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IlActiveCourseCard = void 0;
var il_custom_icon_1 = require("../il-custom-icon/il-custom-icon");
var react_1 = __importDefault(require("react"));
var il_card_1 = require("../il-card/il-card");
var typeography_common_1 = require("../typeography/typeography.common");
var material_1 = require("@mui/material");
var il_select_common_1 = require("../il-select/il-select.common");
var date_fns_1 = require("date-fns");
function IlActiveCourseCard(props) {
    var dateFormat = 'MM/dd/yy';
    var startDateString = (0, date_fns_1.format)(props.startDate, dateFormat);
    var endDateString = (0, date_fns_1.format)(props.endDate, dateFormat);
    var truncateSx = {
        minWidth: '13.5rem',
        width: '13.5rem',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    };
    return (0, il_card_1.IlCard)({
        sx: {
            maxHeight: { xs: '7.0625rem', lg: '5.0625rem' },
            height: '100%',
            margin: '0.375rem',
            width: '17.75rem',
            padding: 0,
            borderWidth: '0.0625rem',
            borderStyle: 'solid',
            borderColor: 'action.disabledBackground',
        },
        contentFlexBoxSx: {
            maxHeight: '2rem',
            height: '2rem',
            padding: '0.75rem',
            paddingBottom: '0.5rem',
        },
        leftSx: {
            display: 'flex',
            alignItems: 'start',
            maxWidth: '2rem',
            maxHeight: '2rem',
        },
        leftContent: react_1.default.createElement(il_custom_icon_1.ILCustomIcon, { type: props.customIconType, sx: { padding: 0 } }),
        centerSx: {
            display: 'flex',
            flexDirection: 'column',
            alignContent: 'flex-start',
            paddingLeft: '0.75rem',
        },
        centerContent: (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(typeography_common_1.ILCaption, { textTransform: 'capitalize', sx: __assign({}, truncateSx) }, props.courseName),
            react_1.default.createElement(typeography_common_1.ILH6, { sx: __assign({}, truncateSx) }, props.assignmentName))),
        rightSx: {
            width: 0,
        },
        showFooter: true,
        footerSx: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'nowrap',
            maxHeight: { xs: '2.85rem', lg: '1.75rem' },
            borderTopStyle: 'solid',
            borderTopWidth: '0.0625rem',
            borderTopColor: 'action.disabledBackground',
            padding: { xs: '0.4rem 0.75rem', lg: '0.25rem 0.75rem' },
        },
        footerContent: (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(material_1.Box, { sx: { width: '100%' } },
                react_1.default.createElement(typeography_common_1.ILCaption, null,
                    startDateString,
                    " - ",
                    endDateString)),
            react_1.default.createElement(il_select_common_1.StaticWeekday, { defaultSelections: props.weekdaySelections }))),
    });
}
exports.IlActiveCourseCard = IlActiveCourseCard;
